import { PaginationAndColumnVisibilityHoc } from "@shared/components";
import { ColumnOptions, DefaultHiddenColumns } from "../utils/constants";
import PartnerChannelsHeader from "../components/PartnerChannelsHeader";
import { PartnerChannelsProps } from "../utils/types";
import PartnerChannelsDataGrid from "../components/partnerChannelsDataGrid";

const PartnerChannels = ({
  visibleColumns,
  setVisibleColumns,
  paginationModel,
  setPaginationModel,
}: PartnerChannelsProps) => {
  return (
    <>
      <PartnerChannelsHeader
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
      <PartnerChannelsDataGrid
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        visibleColumns={visibleColumns}
      />
    </>
  );
};

const transformedColumnOptions = ColumnOptions.map((option) => ({
  ...option,
  field: option.value,
}));

const TransformedInvoiceParties = PaginationAndColumnVisibilityHoc(
  PartnerChannels,
  {
    columnOptions: transformedColumnOptions,
    defaultHiddenColumns: DefaultHiddenColumns,
    storageKey: "partnerChannelsVisibleColumns",
  }
);

export default TransformedInvoiceParties;
